var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-registration-full-screen-layout",class:{ 'show-page': !_vm.isUserRegistrationLoading, 'push-down': _vm.isSlideUpAnimation && !_vm.isStartMoveAnimation }},[_c('div',{staticClass:"layout-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }